import { request } from "../../utils/AxiosInstance";

export const AssignRoleGetApi = async () => {
  return request({
    url: "/get_roles",
  });
};
